import { render, staticRenderFns } from "./bind_device_item.vue?vue&type=template&id=a066f4c6"
import script from "./bind_device_item.vue?vue&type=script&lang=js"
export * from "./bind_device_item.vue?vue&type=script&lang=js"
import style0 from "./bind_device_item.vue?vue&type=style&index=0&id=a066f4c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports